module.exports = __webpack_public_path__ + "static/media/annual-immunization-pharmaceutical-svgrepo-com.f6015d11.svg";